import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay, GetApp } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import { getAllProfile } from "../../../reducer/profile/action";
import { getAllPatent, getAllPatentByProfileId, getFilteredPatent, exportPatent } from "../../../reducer/patent/action";

import PatentInsertModal from "../PatentInsertModal";
import PatentExportModal from "../PatentExportModal";

function PatentButton(props) {
  const { getAllPatent, getAllPatentByProfileId, getAllProfile, getFilteredPatent } = props;

  const [inserting, setInserting] = useState(false);
  const [exporting, setExporting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.listProfile.length === 0) getAllProfile();
  }, [getAllProfile, props.listProfile.length]);

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllPatentByProfileId(profileId);
  }, [profileId]);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredPatent.length === 0 && !props.isFetching)
      getFilteredPatent(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredPatent(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredPatent]);

  const handleReload = () => {
    if (props.type !== "all") {
      getAllPatentByProfileId(profileId);
      props.handleReload();
    } else {
      getFilteredPatent(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };

  const handleInsert = () => setInserting(true);

  const handleExport = () => setExporting(true);

  const handleExportData = async (payload) => {
    await props.exportPatent(payload);
    setExporting(false);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Bằng sáng chế
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<GetApp />}
              style={{ marginLeft: 8 }}
              onClick={handleExport}
            >
              Xuất Excel
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <PatentInsertModal inserting={inserting} setInserting={setInserting} setUpdating={props.setUpdating} />
      <PatentExportModal
        open={exporting}
        onClose={() => setExporting(false)}
        type={props.type === "all" ? "department" : "personal"}
        profileId={props.type === "all" ? 0 : profileId}
        departmentId={props.type === "all" ? props.department : 0}
        exportData={handleExportData}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  isFetching: select(state, "patentReducer", "isFetching"),
  isFetchingAccepted: select(state, "patentReducer", "isFetchingAccepted"),

  listPatent: select(state, "patentReducer", "list"),
  listProfile: select(state, "profileReducer", "list"),
  profileDetail: select(state, "profileReducer", "detail"),
  listPatentById: select(state, "patentReducer", "listById"),
  listFilteredPatent: select(state, "patentReducer", "listFiltered"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllProfile: () => dispatch(getAllProfile()),
  getAllPatent: () => dispatch(getAllPatent()),
  getAllPatentByProfileId: (id) => dispatch(getAllPatentByProfileId(id)),
  getFilteredPatent: (page, pageSize, payload) => dispatch(getFilteredPatent(page, pageSize, payload)),
  exportPatent: (payload) => dispatch(exportPatent(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(PatentButton));

